import xbb from '@xbb/xbb-utils'
import utils from '@/utils'

function bindWXNode() {
  if (window.bindWx) return
  window.bindWx = setTimeout(() => {
    clearTimeout(window.bindWx)
    window.bindWx = undefined
    window.WWOpenData && window.WWOpenData.bindAll(document.querySelectorAll('ww-open-data'))
  }, 0)
}
/**
 * @description: 未绑定自建应用情况下，企微对于用户、部门名称会加密处理，需要调用企微的组件展示名称
 * @param {*} text 传入的id
 * @param {*} type 类型映射 0：用户名称，1：部门名称
 * @return {*}
 */
export const addNodeByWX = (text, type = 0, separator) => {
  // 如果绑定了自建应用 || 非企微环境 || 未初始化
  if (
    utils.xbbLocalStorageGet('wxIsBindApp') !== 'false' ||
    !xbb.isThirdPC(['wx'], true) ||
    utils.xbbLocalStorageGet('ai_wx_init') !== 'success'
  )
    return text
  // 微信名称转换
  text = text === undefined ? '' : text
  type = type === 0 ? 'userName' : 'departmentName'
  let node = `<ww-open-data type=${type} openid=${text} ></ww-open-data>,`
  if (/,|、|，/.test(text) || separator) {
    let splitStr = /,/.test(text) ? ',' : /、/.test(text) ? '、' : '，'
    if (separator) {
      splitStr = separator
    }
    const arr = text.split(splitStr)
    let str = ''
    arr.forEach((item) => {
      str += `<ww-open-data type=${type} openid=${item} ></ww-open-data>` + splitStr
    })
    node = str
  }
  bindWXNode()
  return node.slice(0, -1)
}
